export default "__VITE_ASSET__rMID0Xix__"